module.exports = __webpack_public_path__ + "img/plan-3-6.24f1ff7a.png";